<template>
  <header class="p-2 flex items-center border-b border-gray-300 grid grid-cols-1-auto">
    <div class="text-xl">
      <icon class="-mt-1" name="WaldigLogo" size="1.5em" />
      <span class="ml-2 tracking-wider">STUPSI</span>
    </div>
    <div v-if="user">
      <span class="mx-2 tracking-wide">{{ user.username }}</span>
      <wd-button transparent @input="logout">
        <icon class="-mt-1" name="Logout" size="1.2em" />
      </wd-button>
    </div>
  </header>
</template>

<script>
export default {
  name: "WdHeader",
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {
    back() {
      this.$router.go(-1);
    },
    logout() {
      this.$store.dispatch("auth/logout");
    }
  },
  computed: {
    user() {
      return this.$store.getters["auth/user"];
    }
  },
  created() {}
};
</script>
